import { render, staticRenderFns } from "./TableSettings.vue?vue&type=template&id=300cdfbe&scoped=true&"
import script from "./TableSettings.vue?vue&type=script&lang=ts&"
export * from "./TableSettings.vue?vue&type=script&lang=ts&"
import style0 from "./TableSettings.vue?vue&type=style&index=0&id=300cdfbe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "300cdfbe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
